import { createContext, useContext } from 'react';

interface MobileScanContextValue {
  openScan: () => void;
}

export const MobileScanContext = createContext<MobileScanContextValue>({
  openScan: () => {},
});

/** Hook para abrir o ScanShell de qualquer módulo mobile. */
export function useMobileScan(): MobileScanContextValue {
  return useContext(MobileScanContext);
}
